import { Alert, Row } from "antd";
import { ReactNode, useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import { Link, useNavigate } from "react-router";
import { appName } from "../../../common";
import Title from "../../../views/Components/Title";
import { RoutePaths } from "../../../views/routes";
import { getCurrentUser, signUpWithEmail } from "../../../data/firebase/auth";
import RegistrationForm, { RegisterModel } from "./RegistrationForm";
import BackButton from "../../Components/MobileHeader/BackButton";
import {
  analyticsLogEvent,
  analyticsReportError,
} from "../../../data/firebase/analytics";

interface ErrorType {
  code: keyof typeof errorCodes;
}

const errorCodes = {
  "auth/email-already-in-use": (
    <div>
      This email is already used, try{" "}
      <Link to="/login" viewTransition>
        logging in
      </Link>
    </div>
  ),
  "auth/invalid-email": "Invalid email",
  "auth/operation-not-allowed": "Registration is disabled",
  "auth/weak-password": "Your password is too weak",
};

const redirectRoute = RoutePaths.myDefaultWishlist;

export default function Registration() {
  const [formError, setFormError] = useState<string | ReactNode | undefined>(
    undefined,
  );
  const [successMessage, setSuccessMessage] = useState<string | undefined>(
    undefined,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (getCurrentUser() !== null) {
      analyticsLogEvent("registration_redirect_already_logged_in");
      navigate(redirectRoute);
    }
  });

  const onFinish = async ({ email, password, username }: RegisterModel) => {
    try {
      const user = await signUpWithEmail(email, password, username);
      setSuccessMessage(`Welcome ${user.displayName}!`);
      analyticsLogEvent("registration_redirect");
    } catch (error) {
      const errorCode: keyof typeof errorCodes = (error as ErrorType).code;
      setFormError(
        (error as ErrorType).code in errorCodes
          ? errorCodes[errorCode]
          : "Unknown error",
      );
      analyticsReportError(error as Error);
    }
  };

  return (
    <DocumentTitle title={`${appName} - welcome`}>
      <div className="flex min-h-screen flex-col justify-between">
        <div className="text-base fixed h-12 py-1">
          <BackButton />
        </div>
        <Title>Sign Up</Title>
        <Row
          className={
            "mx-auto flex max-w-sm flex-col content-center items-center justify-center p-5"
          }
        >
          <div className="wish-text">
            Already have an account?{" "}
            <Link to={RoutePaths.login} viewTransition>
              Sign in
            </Link>
          </div>
          {successMessage ? (
            <Alert type="success" message={successMessage} />
          ) : (
            <RegistrationForm onFinish={onFinish} formError={formError} />
          )}
        </Row>
        <Row></Row>
      </div>
    </DocumentTitle>
  );
}
